/**
 * @module https://github.com/wwayne/react-tooltip
 */

import {cloneElement, ReactElement, useId} from 'react';
import {ITooltip, Tooltip as ReactTooltip} from 'react-tooltip';
import styled, {createGlobalStyle, CSSProperties} from 'styled-components';
import {palette} from '@/styles';
import {InfoIconComponent} from '../Icons';

interface IProps extends ITooltip {
  iconStyle?: CSSProperties;
  children?: ReactElement<any>;
}

const options: ITooltip = {
  border: `solid 1px ${palette.black}`,
  noArrow: true,
  opacity: 1,
  place: 'bottom-start',
  offset: 0,
};

export const Tooltip = ({
  children,
  content,
  className,
  iconStyle,
  ...props
}: IProps) => {
  const id = useId();
  const Component = children || <TooltipInfoIcon style={iconStyle} />;
  const tooltipClassName = (
    (className || '') + ' rt-tooltip-custom-class'
  ).trim();

  return (
    <>
      <GlobalTooltipStyle />
      {cloneElement(Component, {
        'data-tooltip-id': id,
        'data-tooltip-content': content,
      })}
      <ReactTooltip
        id={id}
        {...options}
        {...props}
        className={tooltipClassName}
      />
    </>
  );
};

const GlobalTooltipStyle = createGlobalStyle`
  .rt-tooltip-custom-class {
    box-shadow: 0px 4px 10px 0px #00000026 !important;
    padding: 8px 12px !important;
    background-color: ${palette.black} !important;
    font-size: 12px !important;
    font-weight: 500 !important;
    line-height: 16px !important;
    color: ${palette.white} !important;
    pointer-events: auto !important;
    max-width: 320px !important;
    border-radius: 8px !important;
  }
`;

export const TooltipInfoIcon = styled(InfoIconComponent).attrs({
  color: palette.gray400,
})`
  cursor: pointer;
`;

export * from './ActionGuideTooltip';
